import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import {BUTTON_LINE_ICON} from '../../Shared/Constants';
import {
PlusCircleIcon, 
PencilIcon,
ExclamationTriangleIcon
 } from '@heroicons/react/20/solid';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import {getUsers, newUser} from './services/users';
import ClipLoader from "react-spinners/ClipLoader";
import { Switch, Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import ResponsiveTable from '../../Shared/ResponsiveTable';

class ListUsers extends React.Component {
    
    BreadcrumbPages = [
        { name: 'Profesionales', href: '#', current: false },
        { name: 'Lista de Usuarios', href: '#', current: true },
    ]

    columns = [
        {field:'name', headerName: 'Nombre'},
        {field:'userName', headerName: 'Nombre de usuario'},
        {field:'email', headerName: 'Correo electrónico'},
        {field:'roleName', headerName: 'Rol'},
    ]

    constructor(props) {
            super(props);    
            this.state = {
                users: [],
                enabled: false,
                loading:true,
                search:'',
                showConfirmModal: false,
                pendingUser: null,
                pendingActiveValue: null,
                loadingForm: false,
            };
    }

    componentDidMount(){
        this.search();
    }

    handleClick = (event) => {
        this.setState({ currentPage: Number(event.target.id) });
    };

    getCurrentData = () => {
        const { users, itemsPerPage, currentPage } = this.state;
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        return users.slice(indexOfFirstItem, indexOfLastItem);
    };

    openByType = (type, user) => {
        this.props.openDialog(type, user);
    }

    loadTableOptions(){
        if(this.props.canEdit){
            this.columns.pop();
            this.columns.push({
                field:'acciones',
                type:'actions',
                width:200,
                getActions: (params) => [
                    <Switch
                        checked={params.row.active ? true : false}
                        onChange={() => {this.setActive(!params.row.active, params.row)}}
                        className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                    >
                        <span className="sr-only">Use setting</span>
                        <span
                            aria-hidden="true"
                            className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                        />
                    </Switch>,
                    <button 
                        onClick={() => {this.openByType('update', params.row)}}
                        type="button"
                        className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                    > 
                        <PencilIcon aria-hidden="true" className="h-5 w-5" style={{padding:3}}/>
                    </button>
                ]
            })
        }
    }

    renderActions = (row) => {
        if (!this.props.canEdit) return null;
        
        return (
            <div className="flex items-center space-x-2">
                <Switch
                    checked={row.active ? true : false}
                    onChange={() => {this.setActive(!row.active, row)}}
                    className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                </Switch>
                <button 
                    onClick={() => {this.openByType('update', row)}}
                    type="button"
                    className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                > 
                    <PencilIcon aria-hidden="true" className="h-5 w-5" style={{padding:3}}/>
                </button>
            </div>
        );
    }

    search=()=>{
        this.setState({loading:true})
        getUsers({
            limit:0,
            search:this.state.search ? this.state.search : null,
            idType:3,
        }).then((result) => {
            if(result && result.status === 200 && result.data.data.length > 0) {
                const items = result.data.data.map((item)=> { 
                    item.pks = item.id 
                    return item});
                this.setState({
                    users:items,
                    loading:false,
                })
                this.loadTableOptions();
            }else{
                this.setState({
                    users:[],
                    loading:false,
                })
            }
        }).catch(error => console.log(error))
    }

    searchInput = () => {
        return (
            <div style={{display:'flex', flexDirection:'row'}}>
                <div className="relative mt-2 rounded-md shadow-sm" style={{paddingLeft:5}}>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Buscar por nombre de usuario, correo o identificación
                    </label>
                    <input
                        value={this.state.search}
                        onChange={(e) => {this.setState({search:e.target.value})}}
                        id="email"
                        name="email"
                        type="text"
                        placeholder="Buscar"
                        className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm/6"
                        />
                </div>
                <div className='relative mt-2 rounded-md shadows-sm' style={{marginLeft:10, paddingTop:25}}>
                    <button
                        onClick={() => {this.search()}}
                        type="button"
                        className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                        Buscar
                    </button>
                </div>
            </div>
        )
    }

    setActive(value, item){
        // Abrir modal de confirmación
        this.setState({
            showConfirmModal: true,
            pendingUser: item,
            pendingActiveValue: value
        });
    }

    confirmSetActive = () => {
        const { pendingUser, pendingActiveValue } = this.state;
        
        if (!pendingUser) return;
        
        this.setState({loadingForm: true});
        
        newUser({
            id: pendingUser.pks, 
            active: pendingActiveValue, 
            idType: 3, 
            userName: pendingUser.userName,
            name: pendingUser.name,
            email: pendingUser.email,
            roleName: pendingUser.roleName 
        })
        .then((result) => {
            this.setState({
                loadingForm: false,
                showConfirmModal: false,
                pendingUser: null,
                pendingActiveValue: null
            });
            this.search();
        })
        .catch(error => {
            console.log('error', error);
            this.setState({loadingForm: false});
        });
    }

    confirmModal = () => {
        const { pendingUser, pendingActiveValue, showConfirmModal, loadingForm } = this.state;
        const actionText = pendingActiveValue ? 'habilitar' : 'inhabilitar';
        
        return (
            <Dialog open={showConfirmModal} onClose={() => this.setState({showConfirmModal: false})} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
                />
                <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-md data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                        >
                            {!loadingForm ? (
                                <div className="bg-white">
                                    {/* Header */}
                                    <div className="bg-gray-50 border-b border-gray-200 px-6 py-4">
                                        <div className="flex items-center"> 
                                            <ExclamationTriangleIcon className="h-6 w-6 text-gray-600 mr-3" />
                                            <h3 className="text-lg font-semibold text-gray-900">Confirmar Acción</h3>
                                        </div>
                                    </div>

                                    {/* Content */}
                                    <div className="px-6 py-6">
                                        {/* Pregunta principal */}
                                        <div className="mb-6">
                                            <div className="flex items-center mb-4">
                                                <InformationCircleIcon className="h-6 w-6 text-blue-950 mr-3" />
                                                <h4 className="text-lg font-semibold text-gray-900">
                                                    ¿Estás seguro que deseas {actionText} este usuario?
                                                </h4>
                                            </div>
                                            <p className="text-gray-600 text-sm">
                                                Esta acción cambiará el estado del usuario en el sistema.
                                            </p>
                                        </div>

                                        {/* Detalles del usuario */}
                                        <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                                            <h5 className="font-semibold text-gray-900 mb-3">Detalles del Usuario</h5>
                                            
                                            <div className="grid grid-cols-1 gap-3">
                                                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                    <span className="text-sm font-medium text-gray-600">Nombre:</span>
                                                    <span className="text-sm text-gray-900 font-medium">{pendingUser?.name}</span>
                                                </div>
                                                
                                                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                    <span className="text-sm font-medium text-gray-600">Usuario:</span>
                                                    <span className="text-sm text-gray-900 font-medium">{pendingUser?.userName}</span>
                                                </div>
                                                
                                                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                    <span className="text-sm font-medium text-gray-600">Correo:</span>
                                                    <span className="text-sm text-gray-900 font-medium">{pendingUser?.email}</span>
                                                </div>
                                                
                                                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                                                    <span className="text-sm font-medium text-gray-600">Rol:</span>
                                                    <span className="text-sm text-gray-900 font-medium">{pendingUser?.roleName}</span>
                                                </div>
                                                
                                                <div className="flex justify-between items-center py-2">
                                                    <span className="text-sm font-medium text-gray-600">Estado actual:</span>
                                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                        pendingUser?.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                                    }`}>
                                                        {pendingUser?.active ? 'Habilitado' : 'Inhabilitado'}
                                                    </span>
                                                </div>
                                                
                                                <div className="flex justify-between items-center py-2">
                                                    <span className="text-sm font-medium text-gray-600">Nuevo estado:</span>
                                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                        pendingActiveValue ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                                    }`}>
                                                        {pendingActiveValue ? 'Habilitado' : 'Inhabilitado'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Warning Message */}
                                        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mt-4">
                                            <div className="flex">
                                                <div className="flex-shrink-0">
                                                    <svg className="h-5 w-5 text-amber-400" viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                    </svg>
                                                </div>
                                                <div className="ml-3">
                                                    <p className="text-sm text-amber-700">
                                                        Esta acción cambiará el estado de acceso del usuario en el sistema.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="bg-gray-50 px-6 py-4 flex flex-col sm:flex-row gap-3 sm:justify-end">
                                        <button
                                            type="button"
                                            onClick={() => this.setState({showConfirmModal: false, pendingUser: null, pendingActiveValue: null})}
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-colors duration-200"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            onClick={this.confirmSetActive}
                                            type="button"
                                            className="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-white bg-blue-950 border border-transparent rounded-lg hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-colors duration-200 shadow-sm"
                                        >
                                            <ExclamationTriangleIcon className="h-4 w-4 mr-2" />
                                            Confirmar
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-12">
                                    <ClipLoader
                                        color={'black'}
                                        loading={true}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                    <p className="mt-4 text-sm text-gray-600">
                                        {pendingActiveValue ? 'Habilitando usuario...' : 'Inhabilitando usuario...'}
                                    </p>
                                </div>
                            )}
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        );
    }

    render() {
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div class="w-full p-4">
                    <div class="w-full rounded overflow-hidden shadow-lg bg-white" style={{backgroundColor:'#f1f4ff'}}>
                        <div class="px-6 py-4">
                            <p class="text-gray-700 text-base" style={{fontWeight:'bold'}}>
                                En esta sección podrás crear y administrar los usuarios que podrán acceder y hacer uso exclusivo del portal administrativo web.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-white font-semibold text-gray-900">.</h1>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        {
                            this.props.canCreate ? 
                                <button
                                    onClick={() => {this.props.openDialog('new', null)}}
                                    type="button"
                                    className={BUTTON_LINE_ICON}>
                                <PlusCircleIcon aria-hidden="true" className="h-5 w-5 text-white-400"/>
                                    NUEVO USUARIO
                                </button>
                                :
                                null
                        }
                        
                    </div>
                </div>
            
                <div className="sm:flex sm:items-center">
                    {this.searchInput()}
                </div>
                {
                    this.state.loading?
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center>
                        :
                        <div className="mt-8 flow-root">
                            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                        <ResponsiveTable 
                                            data={this.state.users} 
                                            columns={this.columns} 
                                            renderActions={(row) => this.renderActions(row)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                }
                {this.confirmModal()}
            </div>
        )
    }
}

export default ListUsers;